Hop.defineModule('legal-update-acceptance', (root, params) => {
    const CGU_UPDATE_ACKNOWLEDGEMENT_API = '/api/webpref/cgu-version-acceptance-acknowledgement';
    const LAST_CGU_VERSION_API = `/api/seo/content/versions/last?humanId=cgu&locale=${params.currentHostLocale}&type=cgu`;
    let latestVersion;

    const domAcceptCta = root.querySelector('#legalAcceptCta');

    async function isCguAcceptanceAcknowledgementLatestVersion() {
        const [cguVersionAcknowledgement, lastCguVersion] = await Promise.all([
            Hop.get(CGU_UPDATE_ACKNOWLEDGEMENT_API).then((data) => data.text()),
            Hop.get(LAST_CGU_VERSION_API)
                .then((data) => data.text())
                .then((value) => (latestVersion = value)),
        ]);

        return cguVersionAcknowledgement !== lastCguVersion;
    }

    function shouldModalBeDisplayed() {
        const isPageLegal = document.querySelector('#legal-page');
        if (params.showFreelancerCguModalOnUpdate && !isPageLegal) {
            return isCguAcceptanceAcknowledgementLatestVersion();
        }

        return Promise.resolve(false);
    }

    function displayModalIfNeeded(hasToBeDisplayed) {
        if (!hasToBeDisplayed) {
            return;
        }

        $(root).modal('show');
    }

    function acceptCguUpdate() {
        $.post(CGU_UPDATE_ACKNOWLEDGEMENT_API, {
            value: latestVersion,
        });
    }

    function setupListeners() {
        domAcceptCta.addEventListener('click', acceptCguUpdate);
    }

    setupListeners();
    shouldModalBeDisplayed().then(displayModalIfNeeded);

    return function destroy() {
        domAcceptCta.removeEventListener('click', acceptCguUpdate);
    };
});
